/** Email must be valid and end with .com */
export const EMAIL_COM_REGEX = /^[^\s@]+@[^\s@]+\.com$/i;

export function validateEmailCom(email) {
  const trimmed = String(email || '').trim();
  if (!trimmed) return 'Email is required.';
  if (!EMAIL_COM_REGEX.test(trimmed)) {
    return 'Please enter a valid email ending with .com (e.g. name@example.com).';
  }
  return null;
}

export function validatePhone10Digits(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return 'Phone number is required.';
  if (digits.length !== 10) {
    return 'Phone number must be exactly 10 digits.';
  }
  return null;
}

/** Strip non-digits and cap at 10 characters for phone inputs. */
export function normalizePhoneInput(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 10);
}
